import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Grid, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import moment from "moment";
import CreateUpdateWorkflowDialog from "./CreateUpdateWorkflowDialog";

const WorkflowCard = ({
  workflowData,
  onClick,
  setCurrentWorkflow,
  setOpenCreateWorkflowDialog,
  status,
  getWorkflowList,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // State for rename dialog
  const [updateData, setUpdateData] = useState({
    open: false,
    workflowId: null,
    instructionId: null,
    instructionType: null,
    operationType: "",
  });

  const handleMenuOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setIsMenuOpen(false);
  };

  // Menu Option Component
  const WorkflowMenuOption = ({
    text,
    divider = true,
    color,
    onClick,
    disable,
    hidden,
  }) => (
    <>
      <MenuItem
        style={{ color, display: hidden ? "none" : "block" }}
        onClick={onClick}
        disabled={disable}
      >
        {text}
      </MenuItem>
      {divider && (
        <div
          style={{
            borderBottom: "1px solid #dcdce1",
            margin: "0 10px",
          }}
        />
      )}
    </>
  );

  return (
    <>
      {/* Dialog for Update workflow */}
      {updateData?.open && (
        <CreateUpdateWorkflowDialog
          open={updateData.open}
          updateData={updateData}
          getWorkflowList={getWorkflowList}
          handleClose={() =>
            setUpdateData({
              open: false,
              workflowId: null,
              instructionId: null,
              instructionType: null,
            })
          }
        />
      )}

      <Grid
        item
        xs={12}
        m={2}
        sx={{
          backgroundColor:
            workflowData?.WorkFlowStatus?.value === "active" && "#e5faeb",
          borderRadius: 2,
          padding: 2,
          ":hover": {
            backgroundColor:
              workflowData?.WorkFlowStatus?.value === "active" && "#e5faeb",
          },
          cursor: "pointer",
        }}
        className="hoverCard"
        onClick={onClick}
      >
        <Grid display="flex" justifyContent="space-between" alignItems="center">
          <Typography className="serif_display_regular_20 dark_grey">
            {workflowData?.name || ""}
          </Typography>
          <IconButton
            size="small"
            onClick={(e) => handleMenuOpen(e)}
            sx={{
              color: isMenuOpen ? "#00ce3f" : "#000000",
              cursor: "pointer",
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Grid>
        <Typography className="normal_normal_18_Manrope dark_grey">
          {workflowData?.description || ""}
        </Typography>
        <Typography className="normal_normal_16_Manrope dark_grey">
          Last updated on{"  "}
          {moment(workflowData?.updatedAt).format("DD/MM/yyyy") || "NA"}
        </Typography>
      </Grid>
      {/* options section of workflow card  */}
      <Menu
        style={{ border: "2px solid black" }}
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        className="menuPaper"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
      >
        <WorkflowMenuOption
          text="Set as Active"
          color="#00ce3f"
          disable={status !== "Mapping"}
          onClick={() => {
            // setUpdateData({
            //   open: true,
            //   workflowId: workflowData?.id,
            // });
            // handleMenuClose();
          }}
        />

        <WorkflowMenuOption
          text="Rename"
          onClick={() => {
            setUpdateData({
              open: true,
              workflowId: workflowData?.id,
              instructionId: workflowData?.InstructionType?.id,
              instructionType: workflowData?.InstructionType?.name,
              operationType: "rename",
            });
            handleMenuClose();
          }}
          disable={status === "previous_active" || status === "Mapping"}
        />
        <WorkflowMenuOption
          text="Duplicate"
          onClick={() => {
            setUpdateData({
              open: true,
              workflowId: workflowData?.id,
              instructionId: workflowData?.InstructionType?.id,
              instructionType: workflowData?.InstructionType?.name,
              operationType: "duplicate",
            });
            handleMenuClose();
          }}
          disable={status === "Mapping"}
        />
        <WorkflowMenuOption
          text="Delete"
          onClick={() => {
            setUpdateData({
              open: true,
              workflowId: workflowData?.id,
              instructionId: workflowData?.InstructionType?.id,
              instructionType: workflowData?.InstructionType?.name,
              operationType: "delete",
            });
            handleMenuClose();
          }}
          color="#FF0000"
          divider={false}
          disable={status === "active" || status === "Mapping"}
        />
        <WorkflowMenuOption
          text="Edit"
          onClick={() => {
            setUpdateData({
              open: true,
              workflowId: workflowData?.id,
              instructionId: workflowData?.InstructionType?.id,
              instructionType: workflowData?.InstructionType?.name,
              operationType: "edit",
            });
            handleMenuClose();
          }}
          // color="#FF0000"
          divider={false}
          hidden={status !== "Mapping"}
        />
      </Menu>
    </>
  );
};

export default WorkflowCard;
